// extracted by mini-css-extract-plugin
module.exports = {"nav_prev":"nav_prev-2P4Wy","nav_next":"nav_next-2vN8k"};